<template>
  <transition name="fade">
    <div
      v-if="isShow"
      id="vueConfirm"
      class="vc-overlay"
      @click="handleClickOverlay"
    >
      <transition name="zoom">
        <div
          v-if="isShow"
          ref="vueConfirmDialog"
          class="vc-container"
        >
          <span class="vc-text-grid">
            <h4
              v-if="dialog.title"
              class="vc-title"
              v-html="dialog.title"
            />
            <p
              v-if="dialog.message"
              class="vc-text"
              v-html="dialog.message"
            />
            <span>

              <validation-observer ref="confirmcode">
                <b-form-group
                  :label="$t('Code')"
                  label-for="code"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Code')"
                    rules="required"
                  >
                    <b-form-input
                      id="login-code"
                      v-model="code"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="login-code"
                      :placeholder="$t('Code')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </validation-observer>
            </span>
          </span>
          <div
            class="vc-btn-grid"
            :class="{ isMono: !dialog.button.no || !dialog.button.yes }"
          >
            <button
              v-if="dialog.button.no"
              class="vc-btn left"
              type="button"
              @click.stop="e => handleClickButton(e, false)"
            >
              {{ dialog.button.no }}
            </button>

            <button
              v-if="dialog.button.yes"
              class="vc-btn"
              type="button"
              @click.stop="e => handleClickButton(e, true)"
            >
              {{ dialog.button.yes }}
            </button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue'
import {
  BButton, BForm, BFormFile, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { events } from './events'
import { required } from '@/libs/validations/validations'
import { isAdmin } from '@/auth/utils'

Vue.directive('focus', {
  inserted(el) {
    el.focus()
  },
})

const Component = {
  name: 'VueConfirmCode',
  components: {
    BFormInput,
    BFormGroup,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BFormFile,
  },
  data() {
    return {
      required,
      isShow: false,
      code: null,
      dialog: {
        title: 'Are you sure?',
        message: '',
        button: {
          no: 'No',
          yes: 'Yes',
        },
      },
      params: {},
    }
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    resetState() {
      this.code = null
      this.dialog = {
        title: 'Are you sure?',
        message: '',
        button: {
          no: 'No',
          yes: 'Yes',
        },
        callback: () => {},
      }
    },
    handleClickButton({ target }, confirm) {
      if (target.id === 'vueConfirm') return
      if (!confirm) {
        this.close()
        this.params.callback(confirm, this.code)
      }
      this.$refs.confirmcode.validate().then(success => {
        if (success) {
          if (this.params.callback) {
            this.isShow = false
            this.params.callback(confirm, this.code)
          }
        }
      })
    },
    handleClickOverlay({ target }) {
      if (target.id === 'vueConfirm') {
        this.isShow = false
        // callback
        if (this.params.callback) {
          this.params.callback(false, this.code)
        }
      }
    },
    close() {
      this.isShow = false
      this.code = null
    },
    open(params) {
      if (!isAdmin()) {
        this.close()
        params.callback(true, null)
        return
      }
      this.sendCode()
      this.resetState()
      this.params = params
      this.isShow = true
      // set params to dialog state
      Object.entries(params).forEach(param => {
        if (typeof param[1] === typeof this.dialog[param[0]]) {
          // eslint-disable-next-line prefer-destructuring
          this.dialog[param[0]] = param[1]
        }
      })
    },
    sendCode() {
      this.$store.dispatch('staticModule/sendSmsCode')
    },
  },
  mounted() {
    if (!document) return
    events.$on('open', this.open)
    events.$on('close', () => {
      this.handleClickOverlay({ target: { id: 'vueConfirm' } })
    })
    // document.addEventListener('keyup', this.handleKeyUp)
  },
  beforeDestroy() {
    // document.removeEventListener('keyup', this.handleKeyUp)
  },
}

export default Component
</script>

<style>
:root {
  --title-color: black;
  --message-color: black;
  --overlay-background-color: #0000004a;
  --container-box-shadow: #0000004a 0px 3px 8px 0px;
  --base-background-color: #ffffff;
  --button-color: #4083ff;
  --button-background-color: #ffffff;
  --button-border-color: #e0e0e0;
  --button-background-color-disabled: #f5f5f5;
  --button-background-color-hover: #f5f5f5;
  --button-box-shadow-active: inset 0 2px 0px 0px #00000014;
  --input-background-color: #ebebeb;
  --input-background-color-hover: #dfdfdf;
  --font-size-m: 16px;
  --font-size-s: 14px;
  --font-weight-black: 900;
  --font-weight-bold: 700;
  --font-weight-medium: 500;
  --font-weight-normal: 400;
  --font-weight-light: 300;
}

/**
* Dialog
*/

.vc-overlay *,
.vc-overlay *:before,
.vc-overlay *:after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-decoration: none;
  -webkit-touch-callout: none;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}

.vc-title {
  color: var(--title-color);
  padding: 0 1rem;
  width: 100%;
  font-weight: var(--font-weight-black);
  text-align: center;
  font-size: var(--font-size-m);
  line-height: initial;
  margin-bottom: 5px;
}
.vc-text {
  color: var(--message-color);
  padding: 0 1rem;
  width: 100%;
  font-weight: var(--font-weight-medium);
  text-align: center;
  font-size: var(--font-size-s);
  line-height: initial;
}
.vc-overlay {
  background-color: var(--overlay-background-color);
  width: 100%;
  height: 100%;
  transition: all 0.1s ease-in;
  left: 0;
  top: 0;
  z-index: 999999999999;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: baseline;
}
.vc-container {
  background-color: var(--base-background-color);
  border-radius: 1rem;
  width: 286px;
  height: auto;
  display: grid;
  grid-template-rows: 1fr max-content;
  box-shadow: var(--container-box-shadow);
}
.vc-text-grid {
  padding: 1rem;
}
.vc-btn-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 0 0 1rem 1rem;
  overflow: hidden;
}
.vc-btn-grid.isMono {
  grid-template-columns: 1fr;
}
.vc-btn {
  border-radius: 0 0 1rem 0;
  color: var(--button-color);
  background-color: var(--button-background-color);
  border: 0;
  font-size: 1rem;
  border-top: 1px solid var(--button-border-color);
  cursor: pointer;
  font-weight: var(--font-weight-bold);
  outline: none;
  min-height: 50px;
}
.vc-btn:hover {
  background-color: var(--button-background-color-hover);
}
.vc-btn:disabled {
  background-color: var(--button-background-color-disabled);
}
.vc-btn:active {
  box-shadow: var(--button-box-shadow-active);
}
.vc-btn.left {
  border-radius: 0;
  border-right: 1px solid var(--button-border-color);
}
.vc-input[type='code'] {
  width: 100%;
  outline: none;
  border-radius: 8px;
  height: 35px;
  border: 0;
  margin: 5px 0;
  background-color: var(--input-background-color);
  padding: 0 0.5rem;
  font-size: var(--font-size-m);
  transition: 0.21s ease;
}
.vc-input[type='code']:hover,
.vc-input[type='code']:focus {
  background-color: var(--input-background-color-hover);
}

/**
* Transition
*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.21s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.21s;
  animation-fill-mode: both;
  animation-name: zoom;
}

.zoom-leave-active {
  animation-direction: reverse;
}

@keyframes zoom {
  from {
    opacity: 0;
    transform: scale3d(1.1, 1.1, 1.1);
  }

  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
</style>
